type DeviaqMarkProps = {
  size?: number;
  /** När märket visas ensamt (ihopfälld sidomeny) ska det ha ett tillgängligt namn. */
  labelled?: boolean;
  className?: string;
};

/** DeviaQ-kundens logotyp, använd som standard när en kund saknar egen. */
export function DeviaqMark({ size = 48, labelled = false, className }: DeviaqMarkProps) {
  return (
    <img
      src="/deviaq-logo.png"
      width={size}
      height={size}
      alt={labelled ? 'DeviaQ' : ''}
      className={`shrink-0 object-contain ${className ?? ''}`}
      style={{ width: size, height: size }}
      aria-hidden={labelled ? undefined : true}
      draggable={false}
    />
  );
}

type DeviaqDefaultLogoProps = {
  collapsed?: boolean;
};

/** Samma ruta i sidomenyn för standardmärke och kundens egen logotyp. */
export const sidebarLogoSize = (collapsed: boolean) => (collapsed ? 40 : 64);

/** Standardlogotyp när kunden inte har en egen. */
export function DeviaqDefaultLogo({ collapsed = false }: DeviaqDefaultLogoProps) {
  return (
    <>
      <DeviaqMark size={sidebarLogoSize(collapsed)} labelled={collapsed} />
      {!collapsed && (
        <span className="mt-2 text-sm font-semibold text-textDefault">DeviaQ</span>
      )}
    </>
  );
}
